// A simple event bus for cross-component communication
type Callback = (data?: unknown) => void;

interface EventBus {
  events: Record<string, Callback[]>;
  on(event: string, callback: Callback): void;
  dispatch(event: string, data?: unknown): void;
  remove(event: string, callback: Callback): void;
}

const eventBus: EventBus = {
  events: {},

  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  },

  dispatch(event, data) {
    if (this.events[event]) {
      this.events[event].forEach(callback => callback(data));
    }
  },

  remove(event, callback) {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter(cb => cb !== callback);
    }
  },
};

export default eventBus;
